import type { RoleEnumTypeV2 } from '@/features/auth/types'
import type { V1UserDataType } from '@/features/users/types'
import fetchClient from '@/lib/fetch'

export const V1_USER_QUERY_KEY = 'V1_USER_QUERY_KEY'
export function V1GetUser(userId: string, programId: string): Promise<V1UserDataType> {
  return fetchClient(`/v1/user/${userId}/program/${programId}`, {
    method: 'GET',
  })
}

export function deleteUserFromProgram(userId: string, programId: string): Promise<void> {
  return fetchClient(`/v1/programs/${programId}/users/${userId}`, {
    method: 'DELETE',
  })
}

export const V1_USER_PROGRAM_ROLES_QUERY_KEY = 'V1_USER_PROGRAM_ROLES_QUERY_KEY'
export function getUserProgramRoles({
  programId,
  userId,
}: {
  programId: string
  userId: string
}): Promise<{ roles: RoleEnumTypeV2[] }> {
  return fetchClient(`/v1/user-roles?programId=${programId}&userId=${userId}`, {
    method: 'GET',
  })
}

export const V1_USER_GROUP_ROLES_QUERY_KEY = 'V1_USER_GROUP_ROLES_QUERY_KEY'
export function getUserGroupRoles({
  groupId,
  userId,
}: {
  groupId: string
  userId: string
}): Promise<{ roles: RoleEnumTypeV2[] }> {
  return fetchClient(`/v2/groups/user-roles?groupId=${groupId}&userId=${userId}`, {
    method: 'GET',
  })
}
